const initTabs = components => {
  if (!components) {
    return;
  }

  [...components].forEach( component => {
    const tabList = component.querySelector( '[role="tablist"]' );
    const tabs = component.querySelectorAll( '[role="tab"]' );
    const tabPanels = component.querySelectorAll( '[role="tabpanel"]' );

    let tabsIndex = 0;

    tabs.forEach( (tab) => {
      tab.addEventListener( "click", () => {
        changeTabs( tab );
      } );
    } );

    tabList.addEventListener( "keydown", event => {
      if (event.key !== "ArrowRight" && event.key !== "ArrowLeft") {
        return;
      }

      tabs[tabsIndex].setAttribute( "tabtabsIndex", -1 );

      if (event.key === "ArrowRight") {
        tabsIndex++;

        if (tabsIndex >= tabs.length) {
          tabsIndex = 0;
        }
      }

      if (event.key === "ArrowLeft") {
        tabsIndex--;

        if (tabsIndex < 0) {
          tabsIndex = tabs.length - 1;
        }
      }

      tabs[tabsIndex].setAttribute( "tabtabsIndex", 0 );
      tabs[tabsIndex].focus();
      changeTabs( tabs[tabsIndex] );
    } );

    const changeTabs = (nextTab) => {
      const currentPanel = component.querySelector('[aria-hidden="false"]');
      const nextPanel = component.querySelector(`#${nextTab.getAttribute('aria-controls')}`);

      // Update tab states
      tabs.forEach(tab => {
        tab.setAttribute('aria-selected', tab === nextTab);
      });

      // Handle panel transition
      if (currentPanel) {
        currentPanel.setAttribute('aria-hidden', 'true');
      }
      
      // Small delay to ensure smooth animation
      requestAnimationFrame(() => {
        nextPanel.setAttribute('aria-hidden', 'false');
      });
    };
  });
}



export default initTabs;
